import {mapActions, mapState} from "pinia";
import {PointsListItem} from '../pointlistitem/pointslistitem.js';
import {useRoutingStore} from '../../store.js';
import './pointlist.css'

export const PointsList = {
    components: {
        PointsListItem,
    },

    data() {
        return {
            draggedIndex: null, // Индекс перетаскиваемого элемента
            draggingTarget: null, // Перетаскиваемый элемент
            swapped: false,
            inputValue: null,
        };
    },

    computed: {
        ...mapState(useRoutingStore, [
            'RLWaypoints',
            'RLStartPoint',
            'IsCycle',
            'RLRouteLength',
            'RLRouteDuration',
            'clickedAddress',
            'selectedPoints'
        ]),

    },
    mounted(){
        //console.log(this.RLWaypoints[0])
    },

    methods: {
        ...mapActions(useRoutingStore, [
            'swapPoints',
            'deleteWaypoint',
            'setZoomPoint',
            'switchOptimizeState',
            'setCycle',
            'addSelectedPoints',
            'deleteSelectedPoints',
            'addWaypoint'
        ]),
        // Когда перетаскивание начинается
        dragStart(event, index, item) {
            this.draggedIndex = index;
            this.draggingTarget = event.target;
            this.swapped = false;
        },

        // Когда элемент находится над другим
        dragOver(event, index) {
            // Можно добавить визуальное отображение перетаскивания
            event.preventDefault(); // Необходимо для работы события drop
            return
        },

        // Когда элемент сброшен
        drop(event, index) {
            if (this.draggedIndex !== null && this.draggedIndex !== index && !this.swapped) {
                // Вызов действия для замены элементов
                this.swapPoints(this.draggedIndex, index);
                this.switchOptimizeState(false);
                this.swapped = true;
                this.deleteSelectedPoints(null, true)
            }
            // Сброс состояния
            this.draggedIndex = null;
            this.draggingTarget.classList.remove('dragging');
            this.swapped = false;
            if (this.IsCycle) {
                this.deleteWaypoint(this.RLStartPoint)
                this.addWaypoint(this.RLStartPoint)

            }
        },
        selectPoint(event, point) {
            event.target.checked ? this.addSelectedPoints(point) : this.deleteSelectedPoints(point)

        },

        // Удаление точки из выбранных
        deletePoint(point) {
            if (point.ID === this.RLStartPoint.ID){
                this.deleteWaypoint(point);
                this.switchOptimizeState(false);
                this.setCycle(false)
                return
            }
            this.deleteWaypoint(point);
            this.switchOptimizeState(false);
        },
        selectAllPoints(source, points = []) {
            let waypoints = points.length > 0 ? points : this.RLWaypoints
            waypoints.forEach(item => {
                if (source){
                    (this.selectedPoints.includes(item) || item === this.RLStartPoint) ? null : this.addSelectedPoints(item)
                } else {
                    this.deleteSelectedPoints(item)
                }
            })
        },




        HandleClick() {
            this.onClick();
        },
    },

    watch: {
        selectedPoints(newSelectedPoints, oldSelectedPoints) {
            const checkboxes = Array.from(document.getElementsByName('customCheckBox'));
            const mainCheckbox = document.getElementById('main')
            newSelectedPoints.length < oldSelectedPoints.length ? mainCheckbox.checked = false : null

            const newObj = newSelectedPoints.filter(item => !oldSelectedPoints.includes(item))
            const deletedObj = oldSelectedPoints.filter(item => !newSelectedPoints.includes(item))
            if (newObj.length > 0){
                newObj.forEach(elem => {
                    const checkbox = checkboxes.find(item => item.id == elem.ID)
                    checkbox ? checkbox.checked = true : null
                })
            } else if (deletedObj.length > 0) {
                deletedObj.forEach(elem => {
                    const checkbox = checkboxes.find(item => item.id == elem.ID)
                    checkbox ? checkbox.checked = false : null
                })
            }

        },


        deep:true
    },
    // language=Vue
    template:
        `
        <div class="item-object item-object-select-all">
          <input type="checkbox" id="main" class="checkbox-input" @change="(event) => selectAllPoints(event.target.checked)">
          <PointsListItem :text="'Выбрать все'" />
        </div>

        <details>
          <summary>Показать / скрыть</summary>
          <div class="ymap-pointslist_container">
            <template  v-for="(item, index) in RLWaypoints" :key="item.ID">
              <div class="item-object">
              <input v-if="item.ID !== RLStartPoint.ID" type="checkbox"
                     :id="item.ID"
                     class="checkbox-input"
                     name="customCheckBox"
                     @change="(event) => selectPoint(event, item)"
              >
              <input v-if="item.ID === RLStartPoint.ID" type="checkbox"
                     :id="item.ID"
                     class="checkbox-input"
                     name="customCheckBox"
                     disabled=""
              >
                <PointsListItem
                    :number="index+1"
                    :text="item.title"
                    :draggable="true"
                    :removable="true"
                    :onDragStart="(event)=>dragStart(event, index)"
                    :onDragEnd="(event)=>drop(event, index)"
                    :onDragOver="(event)=>dragOver(event, index)"
                    :onDelete="() => deletePoint(item)"
                    :pointIndexIcon="index+1"
                    :additionalClasses="clickedAddress === item.ID ? 'alert' : '' "
                    
                />
                <div v-if="item.workingtime">
                  {{item.workingtime}}
                </div>
              </div>
            </template>
          </div>
        </details>
        `
}

//:onClick="()=>setZoomPoint(item)"